import { Helmet } from "react-helmet-async";

const BASE_URL = "https://flarialmeditours.com";

const defaults = {
  siteName: "Flarial MediTours",
  description: "World-class medical tourism in Kerala, India. Access top hospitals and specialists with complete travel and treatment support. Save 60-90% on treatments including Cardiology, Orthopedics, Oncology, Ayurveda and more.",
  keywords: "medical tourism India, affordable treatment abroad, best hospitals Kerala, Ayurveda Kerala, medical travel India, healthcare India, hospital India, treatment cost India, medical visa India, Panchakarma Kerala",
  image: "https://static.prod-images.emergentagent.com/jobs/3fcdf28a-afce-4eb0-bade-88157aa8ea3c/images/a736bd0af66d8e9f15dad83c033881ee288f185a2f582c1cd8c7f415aca14aa8.png",
};

export default function SEO({ title, description, keywords, path = "", image, type = "website", noindex = false }) {
  const fullTitle = title ? `${title} | ${defaults.siteName}` : `${defaults.siteName} - World-Class Medical Care, Made Simple`;
  const desc = description || defaults.description;
  const kw = keywords || defaults.keywords;
  const img = image || defaults.image;
  const url = `${BASE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content={kw} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={defaults.siteName} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {/* Canonical */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
}
